import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=6485172c&scoped=true"
import script from "./policies.vue?vue&type=script&lang=js"
export * from "./policies.vue?vue&type=script&lang=js"
import style0 from "./policies.vue?vue&type=style&index=0&id=6485172c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485172c",
  null
  
)

export default component.exports